<div class="d-flex flex-column gap-3">
  <div class="d-flex flex-wrap align-items-start justify-content-between gap-2">
    <div>
      <div class="fw-semibold" *ngIf="locationLabel">{{ locationLabel }}</div>
      <div
        class="small text-muted d-flex align-items-center gap-1"
        *ngIf="!loading && seasonChangeEnabled !== null"
      >
        <i class="fa-solid fa-circle-info text-primary" aria-hidden="true"></i>
        <span>
          {{ (seasonChangeEnabled ? 'sunTimesYearlySeasonEnabled' : 'sunTimesYearlySeasonDisabled') | translate }}
        </span>
      </div>
    </div>

    <div class="d-flex flex-wrap align-items-center gap-2">
      <select
        class="form-select form-select-sm w-auto"
        [(ngModel)]="selectedYear"
        (ngModelChange)="onYearChange()"
        [disabled]="loading"
      >
        <option *ngFor="let year of yearOptions" [ngValue]="year">{{ year }}</option>
      </select>

      <button
        type="button"
        class="btn btn-sm btn-outline-primary"
        (click)="downloadCsv()"
        [disabled]="loading || !yearData.length"
      >
        <i class="fas fa-download me-1"></i>
        {{ 'downloadAsCSV' | translate }}
      </button>
    </div>
  </div>

  <div class="d-flex button-group-container justify-content-center w-100">
    <div
      class="text-center button-group px-3 py-2"
      [class.bg-primary]="viewMode === 'chart'"
      [class.text-white]="viewMode === 'chart'"
      (click)="setViewMode('chart')"
      role="button"
    >
      <i class="fas fa-chart-line me-1"></i>
      {{ 'sunTimesViewChart' | translate }}
    </div>
    <div
      class="text-center button-group px-3 py-2"
      [class.bg-primary]="viewMode === 'grid'"
      [class.text-white]="viewMode === 'grid'"
      (click)="setViewMode('grid')"
      role="button"
    >
      <i class="fas fa-th me-1"></i>
      {{ 'sunTimesViewGrid' | translate }}
    </div>
  </div>

  <div class="text-center py-5" *ngIf="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div class="alert alert-danger mb-0" *ngIf="!loading && error">
    {{ error | translate }}
  </div>

  <div
    class="position-relative w-100 border rounded-2 bg-white overflow-hidden chart-area"
    *ngIf="!loading && !error && viewMode === 'chart'"
  >
    <canvas #yearlyChart class="d-block w-100 h-100"></canvas>
  </div>

  <div
    *ngIf="!loading && !error && viewMode === 'grid'"
    #nightGridContainer
    class="position-relative w-100 border rounded-2 bg-white overflow-hidden night-grid-area"
    (mouseleave)="onGridMouseLeave()"
  >
    <canvas
      #nightGridCanvas
      class="d-block w-100 h-100 night-grid-canvas"
      (mousemove)="onGridMouseMove($event)"
    ></canvas>

    <div
      class="position-absolute z-3 p-2 rounded-2 shadow small text-white bg-primary bg-opacity-90"
      *ngIf="gridHover"
      [style.left.px]="gridHover.x"
      [style.top.px]="gridHover.y"
      [style.minWidth.px]="160"
    >
      <div class="fw-semibold">{{ formatDate(gridHover.day.date) }}</div>
      <div>{{ 'sunrise' | translate }}: {{ gridHover.day.sunriseStr }}</div>
      <div>{{ 'sunset' | translate }}: {{ gridHover.day.sunsetStr }}</div>
      <div class="opacity-75">
        {{ gridHover.isNight ? ('sunTimesGridLegendNight' | translate) : ('sunTimesGridLegendDay' | translate) }}
      </div>
    </div>
  </div>

  <div class="flex-shrink-0 pt-2 mt-1 border-top" *ngIf="!loading && !error">
    <div class="d-flex flex-wrap justify-content-center align-items-center gap-3 small text-muted">
      <span class="d-inline-flex align-items-center gap-2">
        <span
          class="d-inline-block rounded border"
          [ngStyle]="{ width: '1rem', height: '1rem', backgroundColor: nightFillColor }"
        ></span>
        {{ 'sunTimesGridLegendNight' | translate }}
      </span>
      <span class="d-inline-flex align-items-center gap-2">
        <span
          class="d-inline-block rounded border"
          [ngStyle]="{ width: '1rem', height: '1rem', backgroundColor: dayFillColor }"
        ></span>
        {{ 'sunTimesGridLegendDay' | translate }}
      </span>
      <span class="d-inline-flex align-items-center gap-2">
        <span
          class="d-inline-block rounded-pill"
          [ngStyle]="{ width: '1.25rem', height: '0.2rem', backgroundColor: sunriseLineColor }"
        ></span>
        {{ 'sunrise' | translate }}
      </span>
      <span class="d-inline-flex align-items-center gap-2">
        <span
          class="d-inline-block rounded-pill"
          [ngStyle]="{ width: '1.25rem', height: '0.2rem', backgroundColor: sunsetLineColor }"
        ></span>
        {{ 'sunset' | translate }}
      </span>
      <span class="d-inline-flex align-items-center gap-2" *ngIf="seasonTransitionMarkers.length">
        <span
          class="d-inline-block"
          [ngStyle]="{ width: '1.25rem', borderTop: '2px dashed ' + seasonTransitionLineColor }"
        ></span>
        {{ 'sunTimesSeasonChangeMarker' | translate }}
      </span>
    </div>
  </div>
</div>
